export default function Version() {
    return (
        <>
            <small>v0.1</small>
        </>
    )
}